import {SuggestionStates, type Suggestion, type SuggestionState} from '../../../conversation-types'
import {AssignToCopilotButton, type AssignToCopilotProps} from './AssignToCopilotButton'
import {
  AutomatedReviewSuggestionApplied,
  AutomatedReviewSuggestionError,
  AutomatedReviewSuggestionOutdated,
  AutomatedReviewSuggestionPending,
  AutomatedReviewSuggestionPresent,
} from './AutomatedReviewSuggestionStates'

export interface AutomatedReviewSuggestionProps {
  automatedCommentId: string
  basePath: string
  foldLongSuggestion?: boolean
  commentAuthorLogin?: string
  commentDatabaseId?: number | null
  commentTitle?: string
  feedbackOptions?: Array<{label: string; value: string}>
  isClassicExperience?: boolean
  suggestion?: Suggestion
  suggestionState?: SuggestionState
  threadId?: string
  fixWithCopilotProps?: {
    commentPermalink: string
    modelsUrl?: string
  }
  assignToCopilotProps?: AssignToCopilotProps
}

const SuggestionStateComponents = {
  [SuggestionStates.Pending]: AutomatedReviewSuggestionPending,
  [SuggestionStates.Error]: AutomatedReviewSuggestionError,
  [SuggestionStates.Outdated]: AutomatedReviewSuggestionOutdated,
  [SuggestionStates.Applied]: AutomatedReviewSuggestionApplied,
  [SuggestionStates.Present]: AutomatedReviewSuggestionPresent, // Default suggestion component
} as const

export function AutomatedReviewSuggestion({
  automatedCommentId,
  basePath,
  foldLongSuggestion,
  commentAuthorLogin,
  commentDatabaseId,
  commentTitle,
  feedbackOptions,
  fixWithCopilotProps,
  assignToCopilotProps,
  isClassicExperience,
  suggestion,
  suggestionState,
  threadId,
}: AutomatedReviewSuggestionProps) {
  if (assignToCopilotProps) {
    return <AssignToCopilotButton {...assignToCopilotProps} />
  }

  if (!suggestionState || suggestionState === SuggestionStates.NoSuggestion) {
    return null
  }

  const SuggestionComponent = SuggestionStateComponents[suggestionState]

  if (!SuggestionComponent) {
    return null
  }

  return (
    <SuggestionComponent
      automatedCommentId={automatedCommentId}
      basePath={basePath}
      foldLongSuggestion={foldLongSuggestion}
      commentTitle={commentTitle}
      commentAuthorLogin={commentAuthorLogin}
      commentDatabaseId={commentDatabaseId}
      feedbackOptions={feedbackOptions}
      fixWithCopilotProps={fixWithCopilotProps}
      isClassicExperience={isClassicExperience}
      suggestion={suggestion}
      threadId={threadId}
    />
  )
}
